import React from "react";
import { withTranslation } from "react-i18next";
import { round2, getInterventionTotals, calculateVatGroups } from "../../../../util/common";
import { TYRE_POSITION } from "../../../../util/tyre";
import "./index.scss";

const TotalAmount = ({ communication, settings, t }) => {
  const { results } = communication;
  const { interventions } = communication.appointment;
  const { vat, total_pdf_enabled, include_vat } = settings;

  if (!total_pdf_enabled) return null;

  const filteredInterventions = interventions.filter(item => item.mechanic_fixed && item.price > 0.01);
  const interventionTotals = getInterventionTotals(filteredInterventions, settings);

  let resultsTotalAmount = 0;
  let additionalPrices = 0;
  const vatRate = vat && include_vat ? 1 + vat / 100 : 1;

  results.forEach(item => {
    if (TYRE_POSITION.IS_TYRE(item.tyre_position) && item.tyre_replacements.length > 0) {
      const rep = item.tyre_replacements.find(rep => rep.mechanic_fixed);
      if (rep && rep.price > 0.01) {
        resultsTotalAmount += rep.price * vatRate;
        additionalPrices += rep.price;
      }
    } else if (item.mechanic_fixed && item.price > 0.01) {
      resultsTotalAmount += item.price * vatRate;
      additionalPrices += item.price;
    }
  });

  const totalAmount = round2(interventionTotals.totalAmount + resultsTotalAmount);
  if (totalAmount <= 0) return null;

  const allVatGroups = calculateVatGroups(interventionTotals.vatGroups, additionalPrices, settings);
  const vatGroups = allVatGroups.filter(group => group.rate > 0 && group.amount > 0);

  return (
    <div className="report-total-amount-container">
      <span>
        {t("cc_total_amount").message || "Total amount"}
        {include_vat &&
          vatGroups.length > 0 &&
          " (" + vatGroups.map(group => (t("cc_vat_included").message || "Incl. VAT") + " " + group.rate + "% - € " + group.amount.toFixed(2)).join(", ") + " )"}
        :&nbsp;&nbsp;&nbsp;&nbsp;€ {totalAmount.toFixed(2)}
      </span>
    </div>
  );
};

export default withTranslation()(TotalAmount);
